import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectFavoritesStyles = makeStyles((theme) =>
  createStyles({
    title: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: theme.spacing(2)
    },

    head: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    },

    titlegroup: {
      display: 'flex',
      alignItems: 'baseline',
      marginRight: theme.spacing(5),
      flexShrink: 0,

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        marginRight: 0,
        marginBottom: theme.spacing(3)
      }
    },

    sort: {
      width: '100%',
      maxWidth: 1055,
      marginBottom: 17,

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: theme.spacing(4)
      }
    },

    paginationBlock: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(8)
    }
  })
)
